import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {AppContext} from 'src/app/shared/services/app.context';
import {URL_PAGE} from "src/app/shared/enums/url.pages.enum";

export const RechercheContenantsGuard = () => {
  const appContext: AppContext = inject(AppContext);
  const router: Router = inject(Router);

  if(appContext.currentUserHasRoleAdmin()) {
    return true;
  }

  return router.navigate([URL_PAGE.HOME]);
}
